// Hero element: animated "Live auto-updating" badge
// This is the centrepiece brand promise — auto-updates
import { useTranslation } from "react-i18next";

export default function LiveBadge() {
  const { t } = useTranslation();
  return (
    <div className="inline-flex items-center gap-3 bg-card/80 border border-accent/30 rounded-full px-4 py-2 backdrop-blur-sm">
      {/* Animated sync icon */}
      <div className="relative w-7 h-7 flex items-center justify-center shrink-0">
        {/* Outer spinning ring */}
        <svg
          className="absolute inset-0 sync-ring"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
        >
          <circle
            cx="14"
            cy="14"
            r="12"
            stroke="hsl(152 55% 40% / 0.3)"
            strokeWidth="2"
            strokeDasharray="4 4"
          />
        </svg>
        {/* Inner solid arc */}
        <svg
          className="absolute inset-0"
          width="28"
          height="28"
          viewBox="0 0 28 28"
          fill="none"
          style={{ animation: "spin-slow 2s linear infinite reverse" }}
        >
          <path
            d="M14 2 A12 12 0 0 1 26 14"
            stroke="hsl(152 55% 40%)"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
        </svg>
        {/* Centre dot */}
        <div className="w-2.5 h-2.5 rounded-full bg-accent live-pulse" />
      </div>

      <div className="flex flex-col gap-0">
        <span
          className="text-sm font-bold uppercase tracking-wider text-accent leading-none"
          style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
        >
          {t("hero.live_badge")}
        </span>
        <span className="text-xs text-muted-foreground leading-none mt-0.5">
          {t("hero.live_badge_sub")}
        </span>
      </div>
    </div>
  );
}
